import axios from 'axios';
import type { Notification } from '@/models/notification';

interface PaginatedNotifications {
    data: Notification[];
    last_page: number;
    current_page: number;
}
class NotificationWebservice {
    public load(page = 1, unreadOnly = false) {
        return axios.get<PaginatedNotifications>(`/notifications?page=${page}&unreadOnly=${unreadOnly}`);
    }
    public markAsRead(notifications: string[]) {
        return axios.put<void>('/notifications/markAsRead', { notifications });
    }
    public markAllAsRead() {
        return axios.put<void>('/notifications/markAsRead/all');
    }
    public count() {
        return axios.get<number>('/notifications/count');
    }
}

export const notificationWebservice = new NotificationWebservice();
